import { makeApolloClient, logError } from '../util';
import { EVENT_POINT, ATTENDEE_POINTS, ATTENDEES_POINTS } from 'queries/point';
import {
	FETCH_ATTENDEE_POINT,
	FETCH_EVENT_POINT,
	DELETE_EVENT_POINT,
	UPDATE_EVENT_POINT,
	CREATE_EVENT_POINT,
	CREATE_ATTENDEE_POINT,
	UPDATE_ATTENDEE_POINT,
	DELETE_ATTENDEE_POINT,
} from './actionTypes';

const fetchEventPoint = (eventPoint, from = '') => ({
	type: FETCH_EVENT_POINT,
	from,
	eventPoint,
});

export const thunkFetchEventPoint = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventPoint } = await client.request(EVENT_POINT, {
			event_id: eventID,
		});
		dispatch(fetchEventPoint(eventPoint, from));
	} catch (error) {
		logError(error, 'point.actions.thunkFetchEventPoint');
	}
};

const fetchAttendeePoints = (attendeePointsByID, from = '') => ({
	type: FETCH_ATTENDEE_POINT,
	from,
	attendeePointsByID,
});

export const thunkFetchAttendeePoints = (attendeeID, eventID, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { attendeePoints } = await client.request(ATTENDEE_POINTS, {
			attendee_id: attendeeID,
			event_id: eventID,
		});
		dispatch(fetchAttendeePoints({ [attendeeID]: attendeePoints }, from));
	} catch (error) {
		logError(error, 'point.actions.fetchAttendeePoints');
	}
};

export const deleteEventPoint = eventPoint => ({
	type: DELETE_EVENT_POINT,
	eventPoint,
});

export const updateEventPoint = eventPoint => ({
	type: UPDATE_EVENT_POINT,
	eventPoint,
});

export const createEventPoint = eventPoint => ({
	type: CREATE_EVENT_POINT,
	eventPoint,
});

export const createAttendeePoint = attendeePoint => ({
	type: CREATE_ATTENDEE_POINT,
	attendeePoint,
});

export const updateAttendeePoint = attendeePoint => ({
	type: UPDATE_ATTENDEE_POINT,
	attendeePoint,
});

export const deleteAttendeePoint = attendeePoint => ({
	type: DELETE_ATTENDEE_POINT,
	attendeePoint,
});

export const gqlFetchAttendeesPoints = async (eventID, token) => {
	const client = makeApolloClient(null, token);
	try {
		const resp = await client.request(ATTENDEES_POINTS, {
			event_id: eventID,
		});
		const { attendeesPoints } = resp;
		return attendeesPoints;
	} catch (error) {
		return logError(error, 'point.actions.fetchAttendeesPoints');
	}
};
